import Vue from 'vue'
import Router from 'vue-router'
import frontendRoutes from './module/frontend'
import { basicMiddleware, authMiddleware, guestMiddleware, gceAuthMiddleware } from './middleware'
Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [...frontendRoutes]
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.title
  if (to.meta.gceAuth) {
    gceAuthMiddleware(next, to)
  }
  if (to.meta.basic) {
    basicMiddleware(next)
  }
  if (to.meta.auth) {
    authMiddleware(next, to)
  }
  if (to.meta.guest) {
    guestMiddleware(next)
  }
})

export default router
